<template>
  <div class="container">
    <h2 class="mt-3">Détails du projet {{ project.name }} de {{ project.clientName }}</h2>
    <h3 class="mt-3">Statut : {{ formattedProjectStatus(project.typeGuid) }}</h3>
    <h3
      class="mt-3"
    >Heures estimées haut niveau : Entre {{ calculateHighLevelHourMin() }} et {{ calculateHighLevelHourMax() }}</h3>
    <h3 class="mt-3">Heures estimées (somme des tâches) : {{ calculateRequirementHours('real') }}</h3>
    <h3 class="mt-3">Heures réelles : {{ calculateHours('real') }}</h3>
    <div class="border-top mt-3">
      <h3 class="mt-3">Description :</h3>
      <div>
        <kez-textarea v-model="project.description" :disabled="!isEditable"/>
      </div>
      <div class="mt-3 text-right">
        <button
          v-if="isEditable"
          type="submit"
          class="btn btn-action btn-lg"
          @click="completeEdit(project)"
        >Sauvegarder</button>
        <button
          v-if="!isEditable"
          type="submit"
          class="btn btn-action btn-lg"
          @click="edit()"
        >Modifier</button>
        <button
          v-if="isEditable"
          type="submit"
          class="btn btn-action btn-lg"
          @click="cancel()"
        >Cancel</button>
      </div>
    </div>
    <div class="border-top mt-3">
      <h3 class="mt-3">Requis :</h3>

      <div is="ProjectRegularTasks" :project-tasks="projectTasks" :project="project.projectGuid"/>
    </div>
    <download-excel :data="excelData" :fields="json_fields" :name="project.name">
      <button type="submit" class="btn btn-primary btn-lg float-right">Télécharger en document excel</button>
    </download-excel>
  </div>
</template>


<script>
import { mapState, mapGetters } from "vuex";
import KezTextarea from "@/components/_forms/KezTextarea";
import ProjectRegularTasks from "@/components/tasks/ProjectRegularTasks";
import { HTTP } from "@/api/index";
import XLSX from "xlsx";

export default {
  components: {
    KezTextarea,
    ProjectRegularTasks
  },
  data() {
    return {
      isEditable: false,
      excelData: [],
      json_fields: {
        Identificateur: "identifierNo",
        "Nom du requis": "name",
        "Total minimum": "totalMin",
        "Total maximum": "totalMax"
      }
    };
  },
  computed: {
    ...mapState("projects", ["project"]),
    ...mapState("projectTasks", ["projectTask", "projectTasks"]),
    ...mapState("regularTasks", [
      "regularTasks",
      "regularTask",
      "filteredRegularTasks"
    ]),
    ...mapState("regularTaskTypes", ["regularTaskTypes"]),
    ...mapState("projectSubTasks", ["filteredProjectSubTasks"]),
    ...mapState("excelExport", ["downloadPath"]),
    ...mapGetters("projectStatusTypes", ["formattedProjectStatus"]),
    ...mapGetters("regularTaskTypes", [
      "formattedRegularTaskTypes",
      "formattedType"
    ])
  },
  watch: {
    projectTasks: {
      handler() {
        this.setExcelData();
      }
    }
  },
  mounted() {
    this.$store.dispatch("projects/get", this.$route.query.id);
    this.$store.dispatch("projectTasks/getList", this.$route.query.id);
    this.$store.dispatch("regularTaskTypes/getList");
    this.$store.dispatch(
      "projectSubTasks/getListByProject",
      this.$route.query.id
    );
  },
  methods: {
    onexport() {
      // On Click Excel download button

      var project = XLSX.utils.json_to_sheet(this.projectTasks);

      // A workbook is the name given to an Excel file
      var wb = XLSX.utils.book_new(); // make Workbook of Excel

      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      XLSX.utils.book_append_sheet(wb, project, "project"); // sheetAName is name of Worksheet

      // export Excel file
      XLSX.writeFile(wb, "book.xlsx"); // name of the file is 'book.xlsx'
    },
    edit() {
      this.isEditable = true;
    },
    cancel() {
      this.isEditable = false;
      this.$store.dispatch("projects/get", this.$route.query.id);
    },
    completeEdit() {
      this.$store.dispatch("projects/save", this.project);
      this.isEditable = false;
    },
    calculateHighLevelHourMin() {
      let hours = 0;
      this.projectTasks.forEach(element => {
        hours += element.totalMin;
      });
      return Math.ceil(hours);
    },
    calculateHighLevelHourMax() {
      let hours = 0;
      this.projectTasks.forEach(element => {
        hours += element.totalMax;
      });
      return Math.ceil(hours);
    },
    calculateRequirementHours() {
      let hours = 0;
      this.projectTasks.forEach(element => {
        this.filteredRegularTasks.forEach(task => {
          if (
            task.relatedProjectRegularTaskGuid == element.taskGuid &&
            task.multiplicator > 0
          ) {
            hours += task.estimatedHours * task.multiplicator;
          }
        });
      });
      return hours;
    },
    calculateHours(type) {
      let hours = 0;
      if (type === "real") {
        this.filteredProjectSubTasks.forEach(element => {
          hours += element.realHours;
        });
      } else {
        this.filteredProjectSubTasks.forEach(element => {
          hours += element.estimatedHours;
        });
      }
      return hours;
    },
    setExcelData() {
      this.excelData = this.projectTasks;
    },
    download() {
      window.open(
        `${HTTP.defaults.baseURL}/ExcelExport/GetProjectDetails?id=${
          this.$route.query.id
        }`
      );
    }
  }
};
</script>

